export default function Contact() {
    return (
        <div>
          <h2> treweathers@proton.me </h2>
          <a className="link2 black" href="https://www.linkedin.com/in/treweathers/"> LinkedIn </a>
        </div>
      )
    }
/*
          <a className="msglink" href="https://docs.google.com/forms/d/e/1FAIpQLSfx8rrHRvZVKwNzhOCqloYEAXB0cLLrBxR9DBzJG3VFVsp2Fg/viewform?usp=sf_link"> Send me a message! </a>

*/
